import Grid from '@mui/material/Grid';
import { FieldDetails } from '@openx/components-core/lib/FieldDetails/FieldDetails';
import { PageSection } from '@openx/components-core/lib/PageSection/PageSection';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import type { GetBidderCreativeQuery } from '../../../../graphql/query/creatives/GetBidderCreative.generated';
import type { ContentCategoryOption } from '../../types';
import { getContentCategoryOptionsMap } from '../../utils';

type CreativeContentDetailsSectionProps = {
  creative: NonNullable<GetBidderCreativeQuery['bidderCreativeById']>;
  iabCategoryOptions: ContentCategoryOption[];
};

export const CreativeContentDetailsSection = ({ creative, iabCategoryOptions }: CreativeContentDetailsSectionProps) => {
  const { t } = useTranslation();

  const iabCategoryOptionsMap = useMemo(() => getContentCategoryOptionsMap(iabCategoryOptions), [iabCategoryOptions]);

  const iabCategories = useMemo(
    () => creative.iab_categories?.map(category => iabCategoryOptionsMap[category] || category),
    [creative.iab_categories, iabCategoryOptionsMap]
  );

  return (
    <PageSection divider title={t('Content Details')}>
      <Grid size="grow">
        <FieldDetails title={t('IAB Categories')} value={iabCategories} />
        <FieldDetails title={t('Advertiser Domain')} value={creative.advertiser_domain} />
      </Grid>
    </PageSection>
  );
};
